import { Show, Suspense, onMount } from "solid-js";

import BackTop from "@/components/Base/BackTop";
import { Loading } from "@/components/Base/Loading/Loading";
import { useDialog } from "@/components/Dialogs/useDialog.ts";
import Cookies from "@/layouts/pc/components/Cookies";
import PCHeader from "@/layouts/pc/components/Header/Header";
import { SidebarContainer } from "@/layouts/pc/components/SidebarContainer/SilebarContainer.tsx";
import { getRealPath } from "@/lib/language";
import { Notification } from "@/pages/pc/notification";
import { sidebarStore } from "@/stores/sidebar";
import { sidebarContainerStore } from "@/stores/sidebarContainerStore.ts";
import { FlowProps } from "@/types/base";
import { useLocation } from "@solidjs/router";

import AppDownloadBanner from "./components/AppDownloadBanner";
import Footer from "./components/Footer";
import Sidebar from "./components/Sidebar/Sidebar";
import VerifyTip from "./components/VerifyTip/verifyTip";

export function PCLobbyLayout(props: FlowProps) {
  const { operateDialog } = useDialog();
  onMount(() => {
    sidebarStore.initSidebar();
    sidebarContainerStore.initSidebar();
  });
  // operateDialog("Minors18Popup", true);

  const hiddenFooter = ["sports"];

  return (
    <>
      <PCHeader />
      <div class="flex gap-6">
        <aside class="sticky top-[var(--header-height)] ml-[6px] flex h-[calc(100vh-var(--header-height))] min-h-0 shrink-0 flex-col">
          <div class="box-border flex min-h-0 flex-1 flex-col py-[10px]">
            <Sidebar />
          </div>
        </aside>
        <main class="relative flex flex-1 flex-col overflow-x-hidden">
          <Suspense
            fallback={
              <div class="min-h-[calc(100vh-var(--header-height))]">
                <Loading />
              </div>
            }
          >
            {props.children}
          </Suspense>

          {/* <Cookies /> */}

          <VerifyTip />
          <AppDownloadBanner />
          <Show
            when={
              !hiddenFooter.includes(
                getRealPath(useLocation().pathname).split("/")[0],
              )
            }
            fallback={<></>}
          >
            <Footer />
          </Show>
        </main>
        {/*通知*/}
        <aside class="sticky top-0 -mt-[var(--header-height)] h-[calc(100vh)]">
          <SidebarContainer state={sidebarContainerStore.state}>
            <Notification />
          </SidebarContainer>
        </aside>
        {/*聊天室*/}
      </div>
      <BackTop />
    </>
  );
}
